import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { Signup } from "../../pages/Auth";

// Investor invitation token (006/RD-4). Optional — plain signup without it.
const signupSearchSchema = z.object({
  invite: z.string().max(64).optional().catch(undefined),
});

export const Route = createFileRoute("/auth/signup")({
  validateSearch: signupSearchSchema,
  component: SignupRoute,
});

function SignupRoute() {
  const { invite } = Route.useSearch();
  return <Signup inviteToken={invite} />;
}
